<div class="wrapper-inner" [ngClass]="{ 'vertical-menu-tooltip-place': (settings.theme.menuType == 'mini' && settings.theme.menu == 'vertical'),
                                        'horizontal-menu-tooltip-place': (settings.theme.menuType == 'mini' && settings.theme.menu == 'horizontal') }">
    
    <app-header></app-header>

    <div class="d-flex h-100" [ngClass]="{'flex-row': settings.theme.menu == 'vertical', 'flex-column': settings.theme.menu != 'vertical'}">
        <app-sidebar *ngIf="settings.theme.menu == 'vertical'"></app-sidebar> 
        <div class="main-content"> 
            
            <!-- USER GUIDE -->
            <div class="help" [ngClass]="{'show': showHelp}">
                <button class="btn btn-default toggle" (click)="showHelp=!showHelp"><i class="fa fa-question-circle-o fa-lg"></i></button>
                <div class="card">
                    <div class="card-header text-center">
                        User Guide
                    </div>              
                    <div class="card-body" *ngIf="help.length > 0">
                           <div *ngFor="let h of help">
                                <h6 *ngIf="h.title.length > 0" class="help-title">
                                    <span><i class="fa {{h.icon}} fa-lg" style="color: black;"></i></span>
                                    <span ><img src="{{h.image}}" onerror="this.style.display='none'" width="30" height="25"></span>
                                   
                                    {{h.title}}
                                </h6>
                                
                                <p class="help-content">{{h.content}}</p>
                                <p class="help-content">{{h.content2}}</p>
                                    <p class="help-main-subcontent">{{h.content2_1}}</p>
                                    <p class="help-main-subcontent">{{h.content2_2}}</p>
                                <p class="help-content">{{h.content3}}</p>
                                    <p class="help-main-subcontent">{{h.content3_1}}</p>
                                        <p class="help-subcontent">{{h.content3_1_1}}</p>
                                        <p class="help-subcontent">{{h.content3_1_2}}</p>
                                        <p class="help-subcontent">{{h.content3_1_3}}</p>
                                        <p class="help-subcontent">{{h.content3_1_4}}</p>
                                        <p class="help-subcontent">{{h.content3_1_5}}</p>
                                    <p class="help-main-subcontent">{{h.content3_2}}</p>
                                        <p class="help-subcontent">{{h.content3_2_1}}</p>
                                        <p class="help-subcontent">{{h.content3_2_2}}</p>
                                        <p class="help-subcontent">{{h.content3_2_3}}</p>
                                        <p class="help-subcontent">{{h.content3_2_4}}</p>
                                        <p class="help-subcontent">{{h.content3_2_5}}</p>
                                        <p class="help-subcontent">{{h.content3_2_6}}</p>
                                        <p class="help-subcontent">{{h.content3_2_7}}</p>
                                        <p class="help-subcontent">{{h.content3_2_8}}</p>
                                    <p class="help-main-subcontent">{{h.content3_3}}</p>
                                        <p class="help-subcontent">{{h.content3_3_1}}</p>
                                        <p class="help-subcontent">{{h.content3_3_2}}</p>
                                        <p class="help-subcontent">{{h.content3_3_3}}</p>
                                        <p class="help-subcontent">{{h.content3_3_4}}</p>
                                    <p class="help-main-subcontent">{{h.content3_4}}</p>
                                        <p class="help-subcontent">{{h.content3_4_1}}</p>
                                        <p class="help-subcontent">{{h.content3_4_2}}</p>
                                        <p class="help-subcontent">{{h.content3_4_3}}</p>
                                    <p class="help-main-subcontent">{{h.content3_5}}</p>
                                        <p class="help-subcontent">{{h.content3_5_1}}</p>
                                        <p class="help-subcontent">{{h.content3_5_2}}</p>
                                        <p class="help-subcontent">{{h.content3_5_3}}</p>
                                        <p class="help-subcontent">{{h.content3_5_4}}</p>
                                        <p class="help-subcontent">{{h.content3_5_5}}</p>
                                        <p class="help-subcontent">{{h.content3_5_6}}</p>
                                        <p class="help-subcontent">{{h.content3_5_7}}</p>
                                        <p class="help-subcontent">{{h.content3_5_8}}</p>
                                    <p class="help-main-subcontent">{{h.content3_6}}</p>
                                        <p class="help-subcontent">{{h.content3_6_1}}</p>
                                        <p class="help-subcontent">{{h.content3_6_2}}</p>
                                        <p class="help-subcontent">{{h.content3_6_3}}</p>
                                    <p class="help-main-subcontent">{{h.content3_7}}</p>
                                        <p class="help-subcontent">{{h.content3_7_1}}</p>
                                        <p class="help-subcontent">{{h.content3_7_2}}</p>
                                        <p class="help-subcontent">{{h.content3_7_3}}</p>
                                        <p class="help-subcontent">{{h.content3_7_4}}</p>
                                        <p class="help-subcontent">{{h.content3_7_5}}</p>
                                        <p class="help-subcontent">{{h.content3_7_6}}</p>
                                        <p class="help-subcontent">{{h.content3_7_7}}</p>
                                        <p class="help-subcontent">{{h.content3_7_8}}</p>
                                        <p class="help-subcontent">{{h.content3_7_9}}</p>
                                        <p class="help-subcontent">{{h.content3_7_10}}</p>
                                        <p class="help-subcontent">{{h.content3_7_11}}</p>
                                        <p class="help-subcontent">{{h.content3_7_12}}</p>
                                    <p class="help-main-subcontent">{{h.content3_8}}</p>
                                        <p class="help-subcontent">{{h.content3_8_1}}</p>
                                        <p class="help-subcontent">{{h.content3_8_2}}</p>
                                    <p class="help-main-subcontent">{{h.content3_9}}</p>
                                <p class="help-content">{{h.content4}}</p>
                                    <p class="help-main-subcontent">{{h.content4_1}}</p>
                                        <p class="help-subcontent">{{h.content4_1_1}}</p>
                                        <p class="help-subcontent">{{h.content4_1_2}}</p>
                                        <p class="help-subcontent">{{h.content4_1_3}}</p>
                                        <p class="help-subcontent">{{h.content4_1_4}}</p>
                                        <p class="help-subcontent">{{h.content4_1_5}}</p>
                                        <p class="help-subcontent">{{h.content4_1_6}}</p>
                                        <p class="help-subcontent">{{h.content4_1_7}}</p>
                                    <p class="help-main-subcontent">{{h.content4_2}}</p>
                                        <p class="help-subcontent">{{h.content4_2_1}}</p>
                                        <p class="help-subcontent">{{h.content4_2_2}}</p>
                                        <p class="help-subcontent">{{h.content4_2_3}}</p>
                                        <p class="help-subcontent">{{h.content4_2_4}}</p>
                                        <p class="help-subcontent">{{h.content4_2_5}}</p>
                                        <p class="help-subcontent">{{h.content4_2_6}}</p>
                                        <p class="help-subcontent">{{h.content4_2_7}}</p>
                                    <p class="help-main-subcontent">{{h.content4_3}}</p>
                                    <p class="help-main-subcontent">{{h.content4_4}}</p>
                                    <p class="help-main-subcontent">{{h.content4_5}}</p>
                                    <p class="help-main-subcontent">{{h.content4_6}}</p>
                                    <p class="help-main-subcontent">{{h.content4_7}}</p>
                                    <p class="help-main-subcontent">{{h.content4_8}}</p>
                                    <p class="help-main-subcontent">{{h.content4_9}}</p>
                                    <p class="help-main-subcontent">{{h.content4_10}}</p>
                                <p class="help-content">{{h.content5}}</p>
                                    <p class="help-main-subcontent">{{h.content5_1}}</p>
                                    <p class="help-main-subcontent">{{h.content5_2}}</p>
                                    <p class="help-main-subcontent">{{h.content5_3}}</p>
                                    <p class="help-main-subcontent">{{h.content5_4}}</p>
                                    <p class="help-main-subcontent">{{h.content5_5}}</p>
                                    <p class="help-main-subcontent">{{h.content5_6}}</p>
                                <p class="help-content">{{h.content6}}</p>
                                    <p class="help-main-subcontent">{{h.content6_1}}</p>
                                        <p class="help-subcontent">{{h.content6_1_1}}</p>
                                        <p class="help-subcontent">{{h.content6_1_2}}</p>
                                        <p class="help-subcontent">{{h.content6_1_3}}</p>
                                        <p class="help-subcontent">{{h.content6_1_4}}</p>
                                        <p class="help-subcontent">{{h.content6_1_5}}</p>
                                        <p class="help-subcontent">{{h.content6_1_6}}</p>
                                        <p class="help-subcontent">{{h.content6_1_7}}</p>
                                        <p class="help-subcontent">{{h.content6_1_8}}</p>
                                        <p class="help-subcontent">{{h.content6_1_9}}</p>
                                        <p class="help-subcontent">{{h.content6_1_10}}</p>
                                    <p class="help-main-subcontent">{{h.content6_2}}</p>
                                    <p class="help-main-subcontent">{{h.content6_3}}</p>
                                    <p class="help-main-subcontent">{{h.content6_4}}</p>
                                    <p class="help-main-subcontent">{{h.content6_5}}</p>
                                    <p class="help-main-subcontent">{{h.content6_6}}</p>
                                <p class="help-content">{{h.content7}}</p>
                                <p class="help-content">{{h.content8}}</p>
                                <p class="help-content">{{h.content9}}</p>
                                <br />

                            </div>
                    </div> 
            
                    <div class="card-body" *ngIf="help.length==0">
                        <h6 class="help-title">About iDrv</h6>
                        <p class="help-content">
                            iDrv is a complete transport management software that can handle almost all logistics operations including invoicing 
                            and compliance
                        </p><br /><br />
                    </div> 
                </div>
            </div> <!--END OF USER GUIDE-->
            
            <!-- SETTINGS -->
            <div class="settings" [ngClass]="{'show2': showSetting}">
                <button class="btn btn-default toggle" (click)="showSetting=!showSetting"><i class="fa fa-spin fa-gear"></i></button>
                <div class="card2">
                    <div class="card-header2 text-center">
                        Settings
                    </div>      
                    <div class="card-body2 mt-2">
                        <h6>Choose menu</h6>  
                        <div class="form-group">
                            <div *ngFor="let menu of menus; let i = index;" class="custom-control custom-radio">
                                <input [attr.id]="'radio-'+i" type="radio" name="menus" class="custom-control-input radio-dark-gray"
                                    (change)="chooseMenu(menu)" [checked]="menu === menuOption" [value]="menu">
                                <label [attr.for]="'radio-'+i" class="custom-control-label text-capitalize">{{menu}}</label>
                            </div>
                        </div>
                    </div> 
                    <div class="card-body2">
                        <h6>Choose menu type</h6>
                        <div class="form-group">
                            <div *ngFor="let menuType of menuTypes; let i = index;" class="custom-control custom-radio">
                                <input [attr.id]="'menuType-'+i" type="radio" name="menuTypes" class="custom-control-input radio-dark-gray"
                                    (change)="chooseMenuType(menuType)" [checked]="menuType === menuTypeOption" [value]="menuType">
                                <label [attr.for]="'menuType-'+i" class="custom-control-label text-capitalize">{{menuType}}</label>
                            </div>
                        </div> 
                    </div> 
                    <div class="card-body2 mb-3">
                        <h6>Choose theme skin</h6>          
                        <div class="theme light" (click)="changeTheme('light')"></div>
                        <div class="theme dark" (click)="changeTheme('dark')"></div>
                        <div class="theme blue" (click)="changeTheme('blue')"></div>
                        <div class="theme green" (click)="changeTheme('green')"></div>
                        <div class="theme combined" (click)="changeTheme('combined')"></div>
                        <div class="theme purple" (click)="changeTheme('purple')"></div>
                        <div class="theme orange" (click)="changeTheme('orange')"></div>
                        <div class="theme brown" (click)="changeTheme('brown')"></div>
                        <div class="theme grey" (click)="changeTheme('grey')"></div>
                        <div class="theme pink" (click)="changeTheme('pink')"></div>
                    </div>  
                    <div class="card-body2 mb-2">
                        <h6>Other theme options</h6> 
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input checkbox-dark-gray" id="navbarIsFixed" [checked]="settings.theme.navbarIsFixed" (change)="changeNavbar()">
                            <label class="custom-control-label" for="navbarIsFixed">Fixed header</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input checkbox-dark-gray" id="sidebarIsFixed" [checked]="settings.theme.sidebarIsFixed" (change)="changeSidebar()">
                            <label class="custom-control-label" for="sidebarIsFixed">Fixed sidebar</label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input checkbox-dark-gray" id="footerIsFixed" [checked]="settings.theme.footerIsFixed" (change)="changeFooter()">
                            <label class="custom-control-label" for="footerIsFixed">Fixed footer</label>
                        </div>
                    </div>
                </div>
            </div>   <!--END OF SETTINGS --> 

            <app-breadcrumb></app-breadcrumb>            
            <router-outlet></router-outlet>              
        </div>
    </div>   

</div>
<app-footer></app-footer>
<app-back-top position="200"></app-back-top>
